import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/:appID/:channelName/:uid/:consultaId/:token/:tipo/:userName" element={<App />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
